// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r-editable-field {
  position: relative;
  min-height: 19px;
  height: 19px;
  width: 100%;
  overflow: visible !important;
}

  .r-editable-field__right-components {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
  }

  .r-editable-field__right-components-content-wrap {
      max-width: 90%;
    }

  .r-editable-field--disabled {
    background: var(--color-grayscale-3);
    pointer-events: none;
  }

  .r-editable-field-label {
    margin: 0;
    margin-right: 6px;
    font-weight: 400;
    flex-shrink: 0;
  }

  .r-editable-field-copy-icon-wrapper {
    position: absolute;
    right: 0;
    top: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .r-editable-field-copy-icon-wrapper:hover {
      color: var(--color-green-8);
    }

  .r-editable-field-copy-icon-wrapper--disabled {
      pointer-events: none;
      color: var(--color-grayscale-5);
    }

  .r-editable-field-copy-icon-wrapper > svg {
      padding-top: 2px;
      height: 15px;
      right: 0;
      cursor: pointer;
    }

  .r-editable-field-content-wrapper {
    display: flex;
    overflow: visible !important;

    /* max-width: 100%; */
    flex-grow: 1;
  }

  .r-editable-field__input {
    height: 19px;
    min-height: 19px !important;
  }

  .r-editable-field__placeholder {
    color: rgb(118 118 118);
  }

  .r-editable-field__textarea {
    min-height: 57px;
    overflow: hidden !important;
  }

  .r-editable-field__textarea-display {
      white-space: normal !important;
    }

  .r-editable-field__textarea-input {
      border: 1px solid var(--color-grayscale-4);
      outline: none;
      width: 100%;
      min-height: 57px;
    }

  .r-editable-field__text {
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    font-weight: 400;
  }

  .r-editable-field__text--editable {
      cursor: pointer;
      border-bottom: solid 1px var(--color-grayscale-4);
    }

  .r-editable-field__text-important {
      display: flex;
      align-items: center;
      color: red;
      text-transform: uppercase;
    }

  .r-editable-field__text-important > svg {
        height: 14px;
        margin-left: 3px;
      }

  .r-editable-field__text--error {
      background-color: var(--color-red-2);
    }

  .r-editable-field input {
    font-family: Avenir, Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
  }

  .r-editable-field__date-time-picker {
    width: 250px;
  }

  .r-editable-field__date-time-picker input {
      height: 19px;
    }

  .r-editable-field--no-underline {
    border-bottom: 0;
  }
`, "",{"version":3,"sources":["webpack://./app/components/EditableField/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,4BAA4B;AAmI9B;;EAjIE;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,aAAa;EAKf;;EAHE;MACE,cAAc;IAChB;;EAGF;IACE,oCAAoC;IACpC,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,2BAA2B;EAiB7B;;EAfE;MACE,2BAA2B;IAC7B;;EAEA;MACE,oBAAoB;MACpB,+BAA+B;IACjC;;EAEA;MACE,gBAAgB;MAChB,YAAY;MACZ,QAAQ;MACR,eAAe;IACjB;;EAGF;IACE,aAAa;IACb,4BAA4B;;IAE5B,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;EAY7B;;EAVE;MACE,8BAA8B;IAChC;;EAEA;MACE,0CAA0C;MAC1C,aAAa;MACb,WAAW;MACX,gBAAgB;IAClB;;EAGF;IACE,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAsBlB;;EApBE;MACE,eAAe;MACf,iDAAiD;IACnD;;EAEA;MACE,aAAa;MACb,mBAAmB;MACnB,UAAU;MACV,yBAAyB;IAM3B;;EAJE;QACE,YAAY;QACZ,gBAAgB;MAClB;;EAGF;MACE,oCAAoC;IACtC;;EAGF;IACE,sCAAsC;IACtC,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;EAKd;;EAHE;MACE,YAAY;IACd;;EAGF;IACE,gBAAgB;EAClB","sourcesContent":[".r-editable-field {\n  position: relative;\n  min-height: 19px;\n  height: 19px;\n  width: 100%;\n  overflow: visible !important;\n\n  &__right-components {\n    position: absolute;\n    right: 0;\n    top: 0;\n    display: flex;\n\n    &-content-wrap {\n      max-width: 90%;\n    }\n  }\n\n  &--disabled {\n    background: var(--color-grayscale-3);\n    pointer-events: none;\n  }\n\n  &-label {\n    margin: 0;\n    margin-right: 6px;\n    font-weight: 400;\n    flex-shrink: 0;\n  }\n\n  &-copy-icon-wrapper {\n    position: absolute;\n    right: 0;\n    top: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n\n    &:hover {\n      color: var(--color-green-8);\n    }\n\n    &--disabled {\n      pointer-events: none;\n      color: var(--color-grayscale-5);\n    }\n\n    & > svg {\n      padding-top: 2px;\n      height: 15px;\n      right: 0;\n      cursor: pointer;\n    }\n  }\n\n  &-content-wrapper {\n    display: flex;\n    overflow: visible !important;\n\n    /* max-width: 100%; */\n    flex-grow: 1;\n  }\n\n  &__input {\n    height: 19px;\n    min-height: 19px !important;\n  }\n\n  &__placeholder {\n    color: rgb(118 118 118);\n  }\n\n  &__textarea {\n    min-height: 57px;\n    overflow: hidden !important;\n\n    &-display {\n      white-space: normal !important;\n    }\n\n    &-input {\n      border: 1px solid var(--color-grayscale-4);\n      outline: none;\n      width: 100%;\n      min-height: 57px;\n    }\n  }\n\n  &__text {\n    display: inline-block;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 100%;\n    font-weight: 400;\n\n    &--editable {\n      cursor: pointer;\n      border-bottom: solid 1px var(--color-grayscale-4);\n    }\n\n    &-important {\n      display: flex;\n      align-items: center;\n      color: red;\n      text-transform: uppercase;\n\n      & > svg {\n        height: 14px;\n        margin-left: 3px;\n      }\n    }\n\n    &--error {\n      background-color: var(--color-red-2);\n    }\n  }\n\n  & input {\n    font-family: Avenir, Arial, sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n  }\n\n  &__date-time-picker {\n    width: 250px;\n\n    & input {\n      height: 19px;\n    }\n  }\n\n  &--no-underline {\n    border-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
